import { render, staticRenderFns } from "./SleepViewFullscreenWelcome.vue?vue&type=template&id=4c502fa8&scoped=true"
import script from "./SleepViewFullscreenWelcome.vue?vue&type=script&lang=js"
export * from "./SleepViewFullscreenWelcome.vue?vue&type=script&lang=js"
import style0 from "./SleepViewFullscreenWelcome.vue?vue&type=style&index=0&id=4c502fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c502fa8",
  null
  
)

export default component.exports